import { useTranslation } from 'react-i18next';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

export const YearlyTaxReportsHeader = () => {
  const { t } = useTranslation();
  return (
    <TableHead>
      <TableRow>
        <TableCell>{t('asset.yearlyTaxReport.table.year')}</TableCell>
        <TableCell>{t('asset.yearlyTaxReport.table.income')}</TableCell>
        <TableCell>{t('asset.yearlyTaxReport.table.taxOffice')}</TableCell>
        <TableCell>{t('asset.yearlyTaxReport.table.taxNumber')}</TableCell>
        <TableCell>{t('asset.yearlyTaxReport.table.taxOfficeTeam')}</TableCell>
        <TableCell>{t('asset.yearlyTaxReport.table.megName')}</TableCell>
        <TableCell>{t('asset.yearlyTaxReport.table.taxRepresentative')}</TableCell>
        <TableCell align="right"></TableCell>
      </TableRow>
    </TableHead>
  );
};
